export default "__VITE_ASSET__DuMxH$gb__"